const cookies = {
  create(name, value, days, host?, path?) {
    const d = days * 24 * 60 * 60;
    cookies.createTmp(name, value, d, host, path);
  },

  createTmp(name, value, secs, host, path) {
    let age = '';
    let domain = '';
    let URL = '; path=/';
    if (secs) {
      const date = new Date();
      date.setTime(date.getTime() + secs * 1000);
      age = `; expires=${date.toUTCString()}`;
    }
    if (host) {
      domain = `; domain=${host}`;
    }
    if (path) {
      URL += path;
    }
    const cookie = `${name}=${value}${age}${domain}${URL}`;
    document.cookie = cookie;
  },

  read(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  remove(name: any, host?: any) {
    cookies.create(name, '', -1, host);
  },
};

export default cookies;
